import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import FormRequestKP from '../components/form/FormRequestKP';
import Event from '../utils/Event';
// @ts-ignore

@Component
export default class VMPromo1 extends Vue {
  openPhone = 0;

  mounted() {
    Event.listen('open-kp', () => {
      this.openForm();
    });
  }

  openForm() {
    this.$modal.show(FormRequestKP,
      {},
      {
        height: 'auto', width: '100%', maxWidth: 1152, adaptive: true, scrollable: true,
        transition: 'nice-modal-fade',
      },
    );
  }
}
